/**
 * Public services entry point. The React shell calls `createServices()` and
 * talks only to the {@link GameServices} interface — it never knows or cares
 * which backend is live. When Firebase is OFF the SDK isn't even imported
 * (dynamic import below), so the bundle stays lean for this test run.
 */
import { firebaseEnabled } from './config';
import { LocalBackend } from './localBackend';
import type { GameServices } from './types';

export async function createServices(): Promise<GameServices> {
  if (firebaseEnabled) {
    const { FirebaseBackend } = await import('./firebaseBackend');
    return new FirebaseBackend();
  }
  return new LocalBackend();
}

export { firebaseEnabled } from './config';
export { RequiresAccountError } from './types';
export type {
  GameServices,
  ScoreEntry,
  ServicesMode,
  AccountTier,
  CurrentUser,
  SubmitRunResult,
  RunReward,
} from './types';
// Firestore read-shapes + the pure quota helper, re-exported so screens can import
// the whole data-access contract from the `services` barrel (rather than reaching
// into `services/dataModel` directly). Covers the replay/showcase + admin surface.
export { replayStarQuota, savedReplayQuota, GAMES, DEFAULT_GAME_ID, NETWORK_RECENT_WINDOW } from './dataModel';
export type {
  AdminMetrics,
  DeathsByFamily,
  EventDoc,
  GameId,
  LeaderboardEntry,
  NetworkStats,
  NewsItem,
  PlayerGameStats,
  ProfileTier,
  RunDoc,
  RunSummary,
  RuntimeConfig,
  StickerCatalogItem,
  UserCard,
  UserProfile,
  WheelConfig,
  WheelResult,
  WheelSlot,
} from './dataModel';
export type {
  MatchPhase,
  MatchPlayer,
  MatchState,
  MultiplayerService,
} from './multiplayer';
export { PlaceholderMultiplayerService } from './multiplayer';
